<template>
  <div>
    <Header :active="active" />
    <Banner />
    <div class="w1300">
      <div class="box1">
        <div class="box1-left">
          <div class="swiper-container2">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="item in gongzuokuaixun"
                :key="item.id"
                @click="goInfo(item.id, '工作快讯', gongzuokuaixun.url)">
              <img :src="imgUrl + item.image" alt="" />
              <p class="article-title">{{ item.title }}</p>
            </div>
          </div>
        </div>
        </div>
        <div class="box1-right">
          <div class="article-list">
            <div class="title">
              <span>工作快讯</span>
              <!-- <span>WORK FLASH</span> -->
              <span @click="goList('工作快讯', 25)">更多>></span>
            </div>
            <ul class="article-ul">
              <li
                v-for="item in gongzuokuaixun"
                :key="item.id"
              @click="goInfo(item.id, '工作快讯', item.url)"
              >
                <span>{{ item.title }}</span>
                <span>{{ item.createTime | truncate(10) }}</span>
              </li>
            </ul>
          </div>
          <div class="article-list">
            <div class="title">
              <span>通知公告</span>
              <!-- <span>HEADLINE NEWS</span> -->
              <span @click="goList('通知公告', 26)">更多>></span>
            </div>
            <ul class="article-ul">
              <li
                v-for="item in tongzhigonggao"
                :key="item.id"
                @click="goInfo(item.id, '通知公告', item.url)"
              >
                <span>{{ item.title }}</span>
                <span>{{ item.createTime | truncate(10) }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="zhongdahuodong">
        <div class="article-list">
          <div class="title">
            <span>重大活动</span>
            <!-- <span>HEADLINE NEWS</span> -->
            <span @click="goList('重大活动', 27)">更多>></span>
          </div>
          <ul class="article-ul">
            <div class="swiper-container1">
              <div class="swiper-wrapper">
                <div
                  v-for="item in zhongdahuodong"
                  :key="item.id"
                  class="swiper-slide article-top"
                  @click="goInfo(item.id, '重大活动', item.url)"
                >
                  <img :src="imgUrl + item.image" alt="" />
                  <p class="article-title">{{ item.title }}</p>
                </div>
              </div>
            </div>
            <!-- <li v-for="item in zhongdahuodong" :key="item.id">
              <span>{{ item.title }}</span>
              <span>{{ item.createTime }}</span>
            </li> -->
          </ul>
        </div>
      </div>
      <div class="box2">
        <div class="box2-left">
          <div>
            <div class="article-list">
              <div class="title">
                <span>县区动态</span>
                <!-- <span>HEADLINE NEWS</span> -->
                <span @click="goCate(2, 13)">更多>></span>
              </div>
              <div
                class="article-top"
                @click="
                  goZixun(
                    xianqudongtai.id,
                    '资讯中心',
                    '县区动态',
                    xianqudongtai.url
                  )
                "
              >
                <img :src="imgUrl + xianqudongtai.image" alt="" />
                <p class="article-title">{{ xianqudongtai.title }}</p>
              </div>
              <ul class="article-ul">
                <li
                  v-for="item in xianqudongtai1"
                  :key="item.id"
                  @click="goZixun(item.id, '资讯中心', '县区动态', item.url)"
                >
                  <span>{{ item.title }}</span>
                  <span>{{ item.createTime | truncate(10) }}</span>
                </li>
              </ul>
            </div>

            <div class="article-list">
              <div class="title">
                <span>基地建设</span>
                <!-- <span>HEADLINE NEWS</span> -->
                <span @click="goCate(2, 14)">更多>></span>
              </div>
              <div
                class="article-top"
                @click="
                  goZixun(
                    jidijianshe.id,
                    '资讯中心',
                    '基地建设',
                    jidijianshe.url
                  )
                "
              >
                <img :src="imgUrl + jidijianshe.image" alt="" />
                <p class="article-title">{{ jidijianshe.title }}</p>
              </div>
              <ul class="article-ul">
                <li
                  v-for="item in jidijianshe1"
                  :key="item.id"
                  @click="goZixun(item.id, '资讯中心', '基地建设', item.url)"
                >
                  <span>{{ item.title }}</span>
                  <span>{{ item.createTime | truncate(10) }}</span>
                </li>
              </ul>
            </div>

            <div class="article-list">
              <div class="title">
                <span>职场信息</span>
                <!-- <span>HEADLINE NEWS</span> -->
                <span @click="goCate(2, 15)">更多>></span>
              </div>
              <div
                class="article-top"
                @click="
                  goZixun(
                    zhichangxinxi.id,
                    '资讯中心',
                    '职场信息',
                    zhichangxinxi.url
                  )
                "
              >
                <img :src="imgUrl + zhichangxinxi.image" alt="" />
                <p class="article-title">{{ zhichangxinxi.title }}</p>
              </div>
              <ul class="article-ul">
                <li
                  v-for="item in zhichangxinxi1"
                  :key="item.id"
                  @click="goZixun(item.id, '资讯中心', '职场信息', item.url)"
                >
                  <span>{{ item.title }}</span>
                  <span>{{ item.createTime | truncate(10) }}</span>
                </li>
              </ul>
            </div>

            <div class="article-list">
              <div class="title">
                <span>风采展示</span>
                <!-- <span>HEADLINE NEWS</span> -->
                <span @click="goCate(2, 16)">更多>></span>
              </div>
              <div
                class="article-top"
                @click="
                  goZixun(
                    fengcaizhanshi.id,
                    '资讯中心',
                    '风采展示',
                    fengcaizhanshi.url
                  )
                "
              >
                <img :src="imgUrl + fengcaizhanshi.image" alt="" />
                <p class="article-title">{{ fengcaizhanshi.title }}</p>
              </div>
              <ul class="article-ul">
                <li
                  v-for="item in fengcaizhanshi1"
                  :key="item.id"
                  @click="goZixun(item.id, '资讯中心', '风采展示', item.url)"
                >
                  <span>{{ item.title }}</span>
                  <span>{{ item.createTime | truncate(10) }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="box2-right">
          <img
            :src="imgUrl + item.image"
            alt=""
            v-for="item in rightImgList"
            :key="item.id"
            @click="redirectToExternalUrl(item.url)"
          />
        </div>
      </div>
    </div>
    <div class="w1300">
      <img :src="imgUrl + buttomImg" alt="" class="foot-img" />
    </div>
    <Foot />
  </div>
</template>
<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
import Header from "../components/header.vue";
import Banner from "../components/banner.vue";
import Foot from "../components/foot.vue";
export default {
  components: {
    Header,
    Banner,
    Foot,
  },
  data() {
    return {
      active: 0,
      imgUrl: this.$imgUrl,
      gongzuokuaixun: [],
      tongzhigonggao: [],
      zhongdahuodong: [],
      xianqudongtai: [],
      xianqudongtai1: [],
      jidijianshe: [],
      jidijianshe1: [],
      zhichangxinxi: [],
      zhichangxinxi1: [],
      fengcaizhanshi: [],
      fengcaizhanshi1: [],
      rightImgList: [],
      buttomImg: "",
    };
  },

  methods: {
    async is_top() {
      let res = await this.$get("/web/index/is_top");
      if (res.code == 200) {
        this.gongzuokuaixun = res.data.news_work;

        this.tongzhigonggao = res.data.news_notice;
        this.zhongdahuodong = res.data.news_event;
        this.xianqudongtai = res.data.dynamic[0];
        res.data.dynamic.splice(0, 1);
        this.xianqudongtai1 = res.data.dynamic;
        this.jidijianshe = res.data.base[0];
        res.data.base.splice(0, 1);
        this.jidijianshe1 = res.data.base;

        this.zhichangxinxi = res.data.workplace[0];
        res.data.workplace.splice(0, 1);
        this.zhichangxinxi1 = res.data.workplace;
        this.fengcaizhanshi = res.data.presence[0];
        res.data.presence.splice(0, 1);
        this.fengcaizhanshi1 = res.data.presence;
      }
    },
    async setting() {
      let res = await this.$get("/web/index/setting");
      if (res.code == 200) {
        this.rightImgList = res.data.links_right_num;
        this.buttomImg = res.data.down_slogan;
        localStorage.setItem("top_slogan", res.data.top_slogan);
      }
    },
    getSwiper1() {
      this.swiper = new Swiper(".swiper-container1", {
        loop: true, // 无缝
        autoplay: {
          //自动开始
          delay: 3000, //时间间隔
          disableOnInteraction: false, //*手动操作轮播图后不会暂停*
        },
        paginationClickable: true,
        slidesPerView: 3, // 一组三个
        spaceBetween: 30, // 间隔
      });
    },
    getSwiper2() {
      this.swiper = new Swiper(".swiper-container2", {
        loop: true, // 无缝
        autoplay: {
          //自动开始
          delay: 3000, //时间间隔
          disableOnInteraction: false, //*手动操作轮播图后不会暂停*
        },
        paginationClickable: true,
        slidesPerView: 1,
        spaceBetween: 30, // 间隔
      });
    },
    goCate(cate_id, children_id) {
      this.$router.push(
        "/zixunzhongxin/" + cate_id + "/" + children_id,
        () => {},
        () => {}
      );
    },
    goZixun(id, cate_title, children_title, url) {
      if (url !== null && url !== undefined && url !== "") {
        window.open(url,'_blank');
      } else {
        this.$router.push(
          "/zixuninfo/" + id + "/" + cate_title + "/" + children_title,
          () => {},
          () => {}
        );
      }
    },
    goList(cate_title, cate_id) {
      this.$router.push(
        "/indexlist/" + cate_title + "/" + cate_id,
        () => {},
        () => {}
      );
    },
    goInfo(id, title, url) {
      if (url !== null && url !== undefined && url !== "") {
        window.open(url,'_blank');
      } else {
        this.$router.push("/info/" + id + "/" + title);
      }
    },
    redirectToExternalUrl(url) {
      window.open(url,'_blank'); // 将当前页面重定向到指定的外部URL
    },
  },
  mounted() {
    this.is_top();
    this.setting();
    setTimeout(() => {
      this.getSwiper1();
    }, 1000);
    setTimeout(() => {
      this.getSwiper2()
    }, 1500);

  },
};
</script>

<style scoped>
.box1 {
  display: flex;
  margin-top: 20px;
}
.box1-left {
  height: 405px;
  flex: 610px 0 0;
  position: relative;
  margin-right: 25px;overflow: hidden;
}
.box1-left img {
  width: 610px;
  height: 405px;
}
.box1-left .swiper-slide{width: 610px;}
.article-title {
  position: absolute;
  bottom: 0;
  height: 50px;
  line-height: 50px;
  background-color: rgba(0, 0, 0, 0.5);
  width: 90%;
  padding: 0 5%;
  color: #fff;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.box1-right {
  width: 660px;
}
.title {
  width: 100%;
  border-bottom: solid 1px #ba0000;
  padding-bottom: 10px;
  color: #b3b3b3;
  font-weight: bold;
}
.title span:first-child {
  font-size: 24px;
  font-weight: bold;
  padding-left: 5px;
  color: #000;
  margin-right: 10px;
}
.title span:last-child {
  font-size: 15px;
  float: right;
  font-weight: normal;
  line-height: 35px;
}
.title span:last-child:hover {
  cursor: pointer;
}
.article-ul {
  margin-top: 10px;
}
.article-ul li {
  margin-top: 15px;
  overflow: hidden;
}
.article-ul li span:first-child {
  width: 70%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  float: left;
}
.article-ul li span:last-child {
  float: right;
  margin-top: 5px;
}
.article-list {
  margin-bottom: 30px;
}
.article-top:hover {
  cursor: pointer;
}
.box2 {
  margin-top: 60px;
  display: flex;
}
.box2-left {
  flex: 1;
}
.box2-left > div {
  display: flex;
  flex-wrap: wrap;
}
.box2-left .article-list {
  width: 49%;
  margin-right: 1%;
  float: left;
}
.box2-left .article-list:nth-child(even) {
  margin-right: 0;
  margin-left: 1%;
}
.box2-right {
  flex: 200px 0 0;
  margin-left: 40px;
  margin-top: 40px;
}
.box2-right img {
  width: 200px;
  height: 130px;
  margin-bottom: 20px;
  border: solid 1px #d76168;
}
.box2-right img:hover {
  cursor: pointer;
}
.box2-right img:last-child {
  margin-bottom: 70px;
}
.box2-left .article-ul li span:first-child {
  width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  float: left;
}
.article-top img {
  width: 100%;
  height: 310px;
}
.article-top {
  position: relative;
  margin-top: 20px;
  height: 310px;
  width: 520px;
}
.box2 .article-title {
  margin-bottom: 0;
}
.foot-img {
  width: 100%;
  /* height: 175px; */
}
.zhongdahuodong {
  margin-top: 20px;
}
li:hover {
  cursor: pointer;
}

.swiper-container1{
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow: hidden;
  list-style: none;
  padding: 0;
  z-index: 1;
}
.swiper-container2{
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow: hidden;
  list-style: none;
  padding: 0;
  z-index: 1;
}
</style>
